import { Link } from "react-router-dom";

const EXPLORE_LINKS = [
  { label: "Products", to: "/products" },
  { label: "Membership", to: "/pricing" },
  { label: "Find my kit", to: "/start" },
  { label: "Gallery", to: "/gallery" },
  { label: "Newsletter", to: "/newsletter" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

const LEGAL_LINKS = [
  { label: "Sign in", to: "/login" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms", to: "/terms" },
];

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#F7F7F4] border-t border-[#E7E7E2]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <Link
              to="/"
              data-testid="footer-wordmark"
              className="font-sora text-[26px] md:text-[30px] font-extrabold tracking-tight text-[#111111] leading-none inline-block"
            >
              Vaymilo<span className="text-[#2563EB]">.</span>
            </Link>
            <p className="mt-4 font-manrope text-[15px] text-[#111111]/65 max-w-md leading-relaxed">
              Simple digital tools for smarter work.
            </p>
            <a
              href="mailto:hello@vaymilo.com"
              data-testid="footer-email"
              className="mt-6 inline-block font-manrope text-[15px] text-[#111111] hover:text-[#2563EB] transition-colors border-b border-[#E7E7E2] hover:border-[#2563EB] pb-0.5"
            >
              hello@vaymilo.com
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#111111]/45">
              Explore
            </div>
            <ul className="mt-5 space-y-3">
              {EXPLORE_LINKS.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="font-manrope text-[15px] text-[#111111]/75 hover:text-[#111111] transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#111111]/45">
              Legal
            </div>
            <ul className="mt-5 space-y-3">
              {LEGAL_LINKS.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="font-manrope text-[15px] text-[#111111]/75 hover:text-[#111111] transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 md:mt-20 border-t border-[#E7E7E2] pt-6 flex items-center justify-between">
          <div className="font-manrope text-[13px] text-[#111111]/55">
            © {year} Vaymilo. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
